module.exports = __webpack_public_path__ + "img/detail-popup-hen.c0c45f88.png";